/**
 * Util that returns the media type.
 * @param mediaUrl Media URL for asset.
 */
export const getCdnMediaType = async (httpClient, mediaUrl) => {
    try {
        const headResponse = await httpClient.head(mediaUrl, { parseResponse: false });
        if (headResponse.status !== 200)
            return undefined;
        return headResponse.headers.get('content-type') || undefined;
    }
    catch (e) {
        return undefined;
    }
};
//# sourceMappingURL=get-cdn-media-type.js.map